define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function isGoogleChrome() {
        return /Chrome/i.test(navigator.userAgent) && /Google Inc/i.test(navigator.vendor);
    }
    exports.isGoogleChrome = isGoogleChrome;
});
